{
  "INBOX_MGMT": {
    "HEADER": "Caixas de Entrada",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Learn more about inboxes",
    "RECONNECT": {
      "BUTTON": "Reconectar",
      "FACEBOOK": "A ligação ao Facebook expirou ou foi revogada. As mensagens enviadas para a página não chegam a esta caixa de entrada e as respostas podem falhar. Uma pessoa que gere a página do Facebook tem de clicar em Reconectar e iniciar sessão no Facebook.",
      "INSTAGRAM": "A ligação ao Instagram expirou ou foi revogada. As mensagens enviadas para a conta não chegam a esta caixa de entrada e as respostas podem falhar. Clique em Reconectar e inicie sessão na mesma conta do Instagram. Outra conta cria uma nova caixa de entrada.",
      "GOOGLE": "A ligação à Google expirou ou foi revogada. Os novos e-mails não chegam a esta caixa de entrada e as respostas podem falhar. Clique em Reconectar e inicie sessão na Google como {email}.",
      "MICROSOFT": "A ligação à Microsoft expirou ou foi revogada. Os novos e-mails não chegam a esta caixa de entrada e as respostas podem falhar. Clique em Reconectar e inicie sessão na Microsoft como {email}.",
      "ALLEGRO": "A ligação ao Allegro expirou ou foi revogada. As mensagens dos compradores não chegam a esta caixa de entrada e as respostas podem falhar. Clique em Reconectar e inicie sessão no Allegro como o vendedor {seller}. Outra conta de vendedor cria uma nova caixa de entrada.",
      "IMAP_LOGIN": "O servidor de correio rejeita o início de sessão IMAP {login}. Os novos e-mails não chegam a esta caixa. Verifique o utilizador e a palavra-passe IMAP no separador {tab} e guarde-os. Continuamos a tentar iniciar sessão e a caixa recupera assim que o início de sessão funcionar.",
      "WHATSAPP": "A ligação ao WhatsApp expirou ou foi revogada. Os anexos dos clientes não chegam a esta caixa de entrada e as respostas podem falhar. Clique em Reconectar, inicie sessão no Facebook e selecione de novo o número {phone}."
    },
    "LIST": {
      "404": "Não há caixas de entrada anexadas a esta conta.",
      "RECONNECT_REQUIRED": "É necessário reconectar"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Escolher canal",
        "BODY": "Escolha o provedor que pretende integrar com o chat."
      },
      "INBOX": {
        "TITLE": "Criar caixa de entrada",
        "BODY": "Autenticar a sua conta e criar uma caixa de entrada."
      },
      "AGENT": {
        "TITLE": "Adicionar agentes",
        "BODY": "Adicionar agentes à caixa de entrada criada."
      },
      "FINISH": {
        "TITLE": "Pronto!",
        "BODY": "Está tudo preparado para começar!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Nome da caixa de entrada",
        "PLACEHOLDER": "Insira o nome da caixa de entrada (ex. Informatico.pt)",
        "ERROR": "Por favor, insira um nome de caixa de entrada válido"
      },
      "WEBSITE_NAME": {
        "LABEL": "Nome do site",
        "PLACEHOLDER": "Insira o nome do seu site (ex. Acme Inc)"
      },
      "INTERNAL_NAME": {
        "LABEL": "Nome interno",
        "PLACEHOLDER": "Nome da caixa de entrada como é apresentado neste painel",
        "ERROR": "Por favor, insira um nome interno único"
      },
      "FB": {
        "HELP": "PS. ao fazer login, só teremos acesso às mensagens da sua página. As suas mensagens privadas nunca poderão ser acedidas por nós.",
        "CHOOSE_PAGE": "Escolher página",
        "CHOOSE_PLACEHOLDER": "Selecionar uma página da lista",
        "INBOX_NAME": "Nome da caixa de entrada",
        "ADD_NAME": "Adicione um nome à sua caixa de entrada",
        "PICK_NAME": "Selecione um nome para a sua caixa de entrada",
        "PICK_A_VALUE": "Escolha um valor",
        "CREATE_INBOX": "Criar caixa de entrada"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Continuar com o Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Ligue o seu perfil do Instagram",
        "HELP": "Para adicionar o seu perfil do Instagram como canal, tem de autenticar o seu perfil do Instagram, clicando em \"Continuar com o Instagram\" ",
        "ERROR_MESSAGE": "Ocorreu um erro ao ligar ao Instagram, tente novamente",
        "ERROR_AUTH": "Ocorreu um erro ao ligar ao Instagram, tente novamente",
        "NEW_INBOX_SUGGESTION": "Esta conta do Instagram estava anteriormente associada a outra caixa de entrada e foi agora migrada para aqui. Todas as novas mensagens vão aparecer aqui. A caixa de entrada anterior deixará de poder enviar ou receber mensagens para esta conta.",
        "DUPLICATE_INBOX_BANNER": "Esta conta do Instagram foi migrada para a nova caixa de entrada do canal do Instagram. Deixará de poder enviar/receber mensagens do Instagram a partir desta caixa de entrada."
      },
      "TWITTER": {
        "HELP": "Para adicionar o seu perfil do Twitter como um canal, precisa de autenticar o seu perfil do Twitter clicando em 'Entrar com o Twitter' ",
        "ERROR_MESSAGE": "Houve um erro de ligação com o Twitter, por favor, tente novamente",
        "TWEETS": {
          "ENABLE": "Criar conversas a partir dos tweets mencionados"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Canal do site",
        "DESC": "Crie um canal para o seu site e comece a oferecer suporte aos seus clientes através do nosso widget do site.",
        "LOADING_MESSAGE": "A criar canal de suporte ao site",
        "CHANNEL_AVATAR": {
          "LABEL": "Avatar do canal"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "URL do Webhook",
          "PLACEHOLDER": "Introduza o seu URL do Webhook",
          "ERROR": "Por favor, insira um URL válido"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Domínio do site",
          "PLACEHOLDER": "Insira o domínio do seu site (ex. acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Título de boas-vindas",
          "PLACEHOLDER": "Olá!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Slogan de boas-vindas",
          "PLACEHOLDER": "Nós simplificamos a sua conexão com os clientes. Pergunte-nos qualquer coisa ou partilhe um comentário."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Mensagem de boas-vindas do canal",
          "PLACEHOLDER": "Acme Inc normalmente responde em algumas horas."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Ativar mensagem de boas-vindas do canal",
          "HELP_TEXT": "Enviar automaticamente uma mensagem de saudação quando uma nova conversa for criada.",
          "ENABLED": "Ativado",
          "DISABLED": "Inativo"
        },
        "REPLY_TIME": {
          "TITLE": "Definir tempo de resposta",
          "IN_A_FEW_MINUTES": "Em poucos minutos",
          "IN_A_FEW_HOURS": "Em poucas horas",
          "IN_A_DAY": "Dentro de um dia",
          "HELP_TEXT": "Este tempo de resposta será mostrado no widget de chat"
        },
        "WIDGET_COLOR": {
          "LABEL": "Cor do widget",
          "PLACEHOLDER": "Atualizar a cor do widget "
        },
        "SUBMIT_BUTTON": "Criar caixa de entrada",
        "API": {
          "ERROR_MESSAGE": "Não foi possível criar um canal de website. Por favor, tente novamente."
        }
      },
      "TWILIO": {
        "TITLE": "Canal SMS/WhatsApp da Twilio",
        "DESC": "Integre o Twilio e comece a oferecer suporte aos seus clientes por SMS ou WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "SID da conta",
          "PLACEHOLDER": "Por favor, insira a sua conta Twilio SID",
          "ERROR": "Este campo é obrigatório"
        },
        "API_KEY": {
          "USE_API_KEY": "Use a autenticação de chave de API",
          "LABEL": "Chave da API SID",
          "PLACEHOLDER": "Por favor, insira a sua chave da API SID",
          "ERROR": "Este campo é obrigatório"
        },
        "API_KEY_SECRET": {
          "LABEL": "Chave secreta da API",
          "PLACEHOLDER": "Por favor, insira a sua chave secreta da API",
          "ERROR": "Este campo é obrigatório"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Serviço de mensagens SID",
          "PLACEHOLDER": "Por favor, insira o SID do seu serviço de mensagens da Twilio",
          "ERROR": "Este campo é obrigatório",
          "USE_MESSAGING_SERVICE": "Use um serviço de mensagens da Twilio"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Tipo de canal",
          "ERROR": "Por favor, selecione o tipo de canal"
        },
        "AUTH_TOKEN": {
          "LABEL": "Token de autenticação",
          "PLACEHOLDER": "Por favor, insira o seu token de autenticação Twilio",
          "ERROR": "Este campo é obrigatório"
        },
        "CHANNEL_NAME": {
          "LABEL": "Nome da caixa de entrada",
          "PLACEHOLDER": "Por favor, insira um nome para a caixa de entrada",
          "ERROR": "Este campo é obrigatório"
        },
        "PHONE_NUMBER": {
          "LABEL": "Número de telefone",
          "PLACEHOLDER": "Por favor, insira o número de telefone a partir do qual a mensagem será enviada.",
          "ERROR": "Por favor, forneça um número de telefone válido, que comece com o sinal de '+' e que não contenha quaisquer espaços."
        },
        "API_CALLBACK": {
          "TITLE": "Link de retorno de ligação",
          "SUBTITLE": "Tem de configurar, aqui, o link de retorno de mensagem no Twilio, através de um URL."
        },
        "SUBMIT_BUTTON": "Criar canal Twilio",
        "API": {
          "ERROR_MESSAGE": "Não foi possível autenticar as credenciais Twilio, por favor, tente novamente"
        }
      },
      "SMS": {
        "TITLE": "Canal SMS",
        "DESC": "Comece a apoiar os seus clientes via SMS.",
        "PROVIDERS": {
          "LABEL": "API Provider",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bandwidth",
          "SMS_BRANA": "SMS Brana",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "Não foi possível guardar o canal de SMS"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "ID da conta",
            "PLACEHOLDER": "Por favor, insira o ID da sua conta Bandwidth",
            "ERROR": "Este campo é obrigatório"
          },
          "API_KEY": {
            "LABEL": "Chave da API",
            "PLACEHOLDER": "Por favor, insira a chave da API da sua Bandwidth",
            "ERROR": "Este campo é obrigatório"
          },
          "API_SECRET": {
            "LABEL": "API Secret",
            "PLACEHOLDER": "Por favor, insira a API Secret da sua  Bandwidth",
            "ERROR": "Este campo é obrigatório"
          },
          "APPLICATION_ID": {
            "LABEL": "ID da aplicação",
            "PLACEHOLDER": "Por favor, insira o ID da aplicação da sua Bandwidth",
            "ERROR": "Este campo é obrigatório"
          },
          "INBOX_NAME": {
            "LABEL": "Nome da caixa de entrada",
            "PLACEHOLDER": "Por favor, insira um nome para a caixa de entrada",
            "ERROR": "Este campo é obrigatório"
          },
          "PHONE_NUMBER": {
            "LABEL": "Número de telefone",
            "PLACEHOLDER": "Por favor, insira o número de telefone a partir do qual a mensagem será enviada.",
            "ERROR": "Por favor, forneça um número de telefone válido que comece com o sinal de '+' e que não contenha quaisquer espaços."
          },
          "SUBMIT_BUTTON": "Criar canal Bandwidth",
          "API": {
            "ERROR_MESSAGE": "Não foi possível autenticar as credenciais Bandwidth, por favor, tente novamente"
          },
          "API_CALLBACK": {
            "TITLE": "URL de retorno da chamada",
            "SUBTITLE": "Tem de configurar o URL de retorno de mensagem na Bandwidth, com o URL mencionado aqui."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Nome da caixa de entrada",
            "PLACEHOLDER": "Por favor, insira um nome para a caixa de entrada",
            "ERROR": "Este campo é obrigatório"
          },
          "PHONE_NUMBER": {
            "LABEL": "Número de telefone",
            "PLACEHOLDER": "Por favor, insira o número de telefone a partir do qual a mensagem será enviada.",
            "ERROR": "Por favor, forneça um número de telefone válido que comece com o sinal `+`."
          },
          "SUBMIT_BUTTON": "Criar canal SMS Brana",
          "API": {
            "ERROR_MESSAGE": "Não foi possível criar o canal SMS Brana"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Nome da caixa de entrada",
            "PLACEHOLDER": "Por favor, insira um nome para a caixa de entrada",
            "ERROR": "Este campo é obrigatório"
          },
          "PHONE_NUMBER": {
            "LABEL": "Número de telefone",
            "PLACEHOLDER": "Por favor, insira o número de telefone a partir do qual a mensagem será enviada.",
            "ERROR": "Por favor, forneça um número de telefone válido que comece com o sinal `+`."
          },
          "SUBMIT_BUTTON": "Criar canal DIDWW",
          "API": {
            "ERROR_MESSAGE": "Não foi possível criar o canal DIDWW"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "API Provider",
          "WHATSAPP_CLOUD": "WhatsApp Cloud"
        },
        "API_CALLBACK": {
          "SUBTITLE": "Deve configurar a URL do webhook e o token de verificação no portal do desenvolvedor do Facebook com os valores apresentados abaixo.",
          "WEBHOOK_URL": "URL do webhook",
          "WEBHOOK_VERIFICATION_TOKEN": "Webhook de verificação do token"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Configuração rápida com a Meta",
          "DESC": "Será redirecionado para a Meta para iniciar sessão na sua conta do WhatsApp Business. Ter acesso de administrador vai ajudar a tornar a configuração simples e fácil.",
          "BENEFITS": {
            "EASY_SETUP": "Não é necessária configuração manual",
            "SECURE_AUTH": "Autenticação segura baseada em OAuth",
            "AUTO_CONFIG": "Configuração automática do webhook e do número de telefone"
          },
          "SUBMIT_BUTTON": "Ligar com o WhatsApp Business",
          "AUTH_PROCESSING": "A autenticar com a Meta",
          "WAITING_FOR_BUSINESS_INFO": "Por favor, conclua a configuração da empresa na janela da Meta...",
          "PROCESSING": "A configurar a sua conta do WhatsApp Business",
          "CANCELLED": "O registo do WhatsApp foi cancelado",
          "WAITING_FOR_AUTH": "A aguardar autenticação...",
          "INVALID_BUSINESS_DATA": "Dados da empresa inválidos recebidos do Facebook. Tente novamente.",
          "SIGNUP_ERROR": "Ocorreu um erro no registo",
          "SDK_LOAD_ERROR": "Não foi possível carregar o SDK do Facebook. Tente novamente.",
          "AUTH_NOT_COMPLETED": "Autenticação não concluída. Reinicie o processo.",
          "SUCCESS_FALLBACK": "A conta do WhatsApp Business foi configurada com sucesso",
          "RECONNECTED": "Canal do WhatsApp reconectado com sucesso"
        },
        "API": {
          "ERROR_MESSAGE": "Não foi possível gravar o canal do WhatsApp"
        }
      },
      "API_CHANNEL": {
        "TITLE": "Canal da API",
        "DESC": "Integrar com o canal API para dar apoio aos seus clientes.",
        "CHANNEL_NAME": {
          "LABEL": "Nome do canal",
          "PLACEHOLDER": "Por favor, insira um nome para o canal",
          "ERROR": "Este campo é obrigatório"
        },
        "WEBHOOK_URL": {
          "LABEL": "URL do Webhook",
          "SUBTITLE": "Configurar o URL onde pretende receber mensagens de retorno.",
          "PLACEHOLDER": "URL do webhook"
        },
        "SUBMIT_BUTTON": "Criar canal API",
        "API": {
          "ERROR_MESSAGE": "Não foi possível guardar o canal API"
        }
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Canal Salesforce",
        "DESC": "Integre com o canal Salesforce e comece a apoiar os seus clientes.",
        "CHANNEL_NAME": {
          "LABEL": "Nome do canal",
          "PLACEHOLDER": "Por favor, insira um nome para o canal",
          "ERROR": "Este campo é obrigatório"
        },
        "API_BASE_URL": {
          "LABEL": "URL da API do Salesforce",
          "SUBTITLE": "Configure o URL base da sua instância do Salesforce.",
          "PLACEHOLDER": "URL da API do Salesforce"
        },
        "KEY_ID": {
          "LABEL": "ID da chave",
          "SUBTITLE": "ID da chave do seu canal Salesforce.",
          "PLACEHOLDER": "ID DA CHAVE"
        },
        "SECRET": {
          "LABEL": "Segredo",
          "SUBTITLE": "Segredo do seu canal Salesforce.",
          "PLACEHOLDER": "*****"
        },
        "SUBMIT_BUTTON": "Criar canal Salesforce",
        "API": {
          "ERROR_MESSAGE": "Não foi possível guardar o canal Salesforce"
        },
        "API_CALLBACK": {
          "TITLE": "URL do webhook",
          "SUBTITLE": "Tem que configurar o URL do webhook no Salesforce com o URL mencionado aqui."
        },
        "BEARER_TOKEN": {
          "TITLE": "Token Bearer",
          "SUBTITLE": "Utilize este token Bearer para autenticação ao configurar o webhook no Salesforce."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "Substituir remetente do e-mail",
          "SUBTITLE": "Se definido, este endereço de e-mail será utilizado como remetente de todos os e-mails enviados, em vez do e-mail de origem da conversa.",
          "PLACEHOLDER": "por ex. support{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Canal Allegro",
        "DESC": "Ligue uma conta de vendedor Allegro e responda às suas mensagens a partir do centro de contacto.",
        "CHANNEL_NAME": {
          "LABEL": "Nome da caixa de entrada",
          "SUBTITLE": "O nome que os agentes veem para esta caixa de entrada.",
          "PLACEHOLDER": "Insira um nome para a caixa de entrada",
          "ERROR": "Este campo é obrigatório"
        },
        "SUBMIT_BUTTON": "Entrar com o Allegro",
        "API": {
          "ERROR_MESSAGE": "Ocorreu um erro ao ligar ao Allegro, por favor, tente novamente"
        },
        "SELLER_LOGIN": {
          "TITLE": "Início de sessão Allegro",
          "SUBTITLE": "A conta de vendedor cujas mensagens esta caixa de entrada lê e responde."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Canal Kaufland",
        "DESC": "Responda às mensagens de tickets que os compradores lhe enviam no marketplace Kaufland.",
        "CHANNEL_NAME": {
          "LABEL": "Nome do canal",
          "PLACEHOLDER": "Por favor, insira um nome para o canal",
          "ERROR": "Este campo é obrigatório"
        },
        "CLIENT_KEY": {
          "LABEL": "Client Key",
          "SUBTITLE": "A Client Key (chave de cliente) de 32 caracteres da página de definições de API da sua conta de vendedor Kaufland.",
          "PLACEHOLDER": "Chave de 32 caracteres",
          "ERROR": "Insira a Client Key de 32 caracteres"
        },
        "SECRET_KEY": {
          "LABEL": "Secret Key",
          "SUBTITLE": "A Secret Key (chave secreta) de 64 caracteres que pertence à Client Key. O Kaufland mostra-a uma única vez e nunca a devolve a esta página.",
          "PLACEHOLDER": "Chave de 64 caracteres",
          "ERROR": "Insira a Secret Key de 64 caracteres"
        },
        "SUBMIT_BUTTON": "Criar canal Kaufland",
        "API": {
          "ERROR_MESSAGE": "Não foi possível guardar o canal Kaufland"
        },
        "DISCONNECTED": {
          "TITLE": "Desconectado",
          "MESSAGE": "O Kaufland rejeitou estas chaves de API. Insira novamente a client key e a secret key para voltar a ligar esta caixa de entrada."
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "Canal de e-mail",
        "DESC": "Integre a sua caixa de entrada de e-mail.",
        "CHANNEL_NAME": {
          "LABEL": "Nome do canal",
          "PLACEHOLDER": "Por favor, insira um nome para o canal",
          "ERROR": "Este campo é obrigatório"
        },
        "EMAIL": {
          "LABEL": "E-mail",
          "SUBTITLE": "E-mail para o qual os seus clientes enviam os tickets de suporte",
          "PLACEHOLDER": "E-mail"
        },
        "SUBMIT_BUTTON": "Criar canal de e-mail",
        "API": {
          "ERROR_MESSAGE": "Não foi possível guardar o canal de e-mail"
        },
        "FINISH_MESSAGE": "Comece a encaminhar as suas mensagens de e-mail para o seguinte endereço."
      },
      "LINE_CHANNEL": {
        "TITLE": "Canal LINE",
        "DESC": "Integre com o canal LINE e comece a apoiar os seus clientes.",
        "CHANNEL_NAME": {
          "LABEL": "Nome do canal",
          "PLACEHOLDER": "Por favor, insira um nome para o canal",
          "ERROR": "Este campo é obrigatório"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "ID do canal LINE",
          "PLACEHOLDER": "ID do canal LINE"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "Secret do canal LINE",
          "PLACEHOLDER": "Secret do canal LINE"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "Token do canal LINE",
          "PLACEHOLDER": "Token do canal LINE"
        },
        "SUBMIT_BUTTON": "Criar canal LINE",
        "API": {
          "ERROR_MESSAGE": "Não foi possível guardar o canal LINE"
        },
        "API_CALLBACK": {
          "TITLE": "URL de retorno da chamada",
          "SUBTITLE": "Tem que configurar o URL do webhook na aplicação LINE com o URL mencionado aqui."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Canal Telegram",
        "DESC": "Integre com o canal Telegram e comece a apoiar os seus clientes.",
        "BOT_TOKEN": {
          "LABEL": "Token do bot",
          "SUBTITLE": "Configure o token do bot que obteve do Telegram BotFather.",
          "PLACEHOLDER": "Token do bot"
        },
        "SUBMIT_BUTTON": "Criar canal Telegram",
        "API": {
          "ERROR_MESSAGE": "Não foi possível guardar o canal Telegram"
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Chamadas telefónicas",
        "DESC": "Configure que chamadas telefónicas aparecem nesta caixa de entrada.",
        "NAME": {
          "LABEL": "Nome da caixa de entrada",
          "SUBTITLE": "Escolha um nome facilmente identificável."
        },
        "PHONE_NUMBER": {
          "LABEL": "Número de telefone",
          "SUBTITLE": "Introduza os números de telefone que pertencem a esta caixa de entrada; pode adicionar mais números mais tarde.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "Criar caixa de entrada de chamadas telefónicas",
        "API": {
          "ERROR_MESSAGE": "Não foi possível criar a caixa de entrada"
        }
      },
      "AUTH": {
        "TITLE": "Escolher um canal",
        "DESC": "O chat suporta widgets de live-chat, Facebook Messenger, WhatsApp, E-mails, etc., como canais. Se pretende criar um canal personalizado, pode fazê-lo usando o canal API. Para começar, escolha um dos canais abaixo."
      },
      "AGENTS": {
        "TITLE": "Agentes",
        "DESC": "Aqui você pode adicionar agentes para gerenciar a sua caixa de entrada recém-criada. Apenas esses agentes selecionados terão acesso à sua caixa de entrada. Agentes que não fazem parte desta caixa de entrada não serão capazes de ver ou responder a mensagens nesta caixa de entrada quando eles acessarem. <br> <b>PS:</b> como administrador, se precisar de acesso a todas as caixas de entrada, você deve se adicionar como agente em todas as caixas de entrada que você criar.",
        "VALIDATION_ERROR": "Adicione, pelo menos, um agente à sua nova caixa de entrada",
        "PICK_AGENTS": "Escolha os agentes da caixa de entrada"
      },
      "DETAILS": {
        "TITLE": "Detalhes da caixa de entrada",
        "DESC": "No menu abaixo, selecione a página do Facebook que pretende conectar ao chat. Também pode dar um nome personalizado à sua caixa de entrada para uma melhor identificação."
      },
      "FINISH": {
        "TITLE": "Excelente!",
        "DESC": "A integração da sua página do Facebook com o chat foi feita com sucesso. Da próxima vez que um cliente enviar mensagens para sua página, a conversa aparecerá automaticamente na sua caixa de entrada.<br>Também fornecemos um script de widget que pode facilmente adicionar ao seu site. Uma vez que isto estiver no seu site, os clientes podem enviar mensagens a partir do site sem a ajuda de qualquer ferramenta externa e a conversa aparecerá aqui, no chat.<br>"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Selecione o seu fornecedor de e-mail",
        "DESCRIPTION": "Selecione um fornecedor de e-mail da lista abaixo. Se não encontrar o seu fornecedor de e-mail na lista, pode selecionar a opção 'Outros fornecedores' e colocar as credenciais IMAP e SMTP."
      },
      "MICROSOFT": {
        "TITLE": "E-mail Microsoft",
        "DESCRIPTION": "Para começar, clique no botão 'Entrar com a Microsoft'. Será redirecionado para o e-mail. Depois de aceitar as permissões solicitadas, será redirecionado novamente para a etapa de criação da caixa de entrada.",
        "EMAIL_PLACEHOLDER": "Insira o endereço de e-mail",
        "SIGN_IN": "Entrar via Microsoft",
        "ERROR_MESSAGE": "Ocorreu um erro ao ligar à Microsoft, por favor, tente novamente"
      },
      "GOOGLE": {
        "TITLE": "E-mail Google",
        "DESCRIPTION": "Para começar, clique no botão 'Entrar com o Google'. Será redirecionado para a página de login do e-mail. Depois de aceitar as permissões solicitadas, será redirecionado de volta para a etapa de criação da caixa de entrada. ",
        "SIGN_IN": "Entrar com o Google",
        "EMAIL_PLACEHOLDER": "Insira o endereço de e-mail",
        "ERROR_MESSAGE": "Ocorreu um erro ao conectar ao Google, por favor, tente novamente"
      }
    },
    "DETAILS": {
      "LOADING_FB": "A autenticá-lo com o Facebook...",
      "ERROR_FB_LOADING": "Erro ao carregar o SDK do Facebook. Por favor, inative qualquer bloqueador de anúncios e tente novamente, num navegador diferente.",
      "ERROR_FB_AUTH": "Ocorreu um erro! Por favor, atualize a página...",
      "ERROR_FB_UNAUTHORIZED": "Não tem permissão para executar esta ação. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Por favor, certifique-se que tem acesso à página do Facebook, com controlo total. Pode ler mais sobre as permissões do Facebook <a href=\"https://www.facebook.com/help/187316341316631\">aqui</a>.",
      "ERROR_CHANNEL_CREATION": "Não foi possível criar a caixa de entrada. Por favor, tente novamente.",
      "CREATING_CHANNEL": "A criar a sua caixa de entrada...",
      "TITLE": "Configurar detalhes da caixa de entrada",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Adicionar agentes",
      "ADD_AGENTS": "A adicionar agentes à sua caixa de entrada..."
    },
    "FINISH": {
      "TITLE": "A sua caixa de entrada está pronta!",
      "MESSAGE": "Agora, pode conectar-se com os seus clientes através do seu novo canal.",
      "BUTTON_TEXT": "Ir para a caixa de entrada",
      "MORE_SETTINGS": "Mais configurações",
      "WEBSITE_SUCCESS": "Acabou de criar um canal de site com sucesso. Copie o código mostrado abaixo e cole-o no seu site. Da próxima vez que um cliente usar o chat em tempo real, a conversa aparecerá automaticamente na sua caixa de entrada."
    },
    "REAUTH": "Reautorizar",
    "VIEW": "Ver",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Configurações da caixa de entrada atualizadas com sucesso",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Atribuição automática atualizada com sucesso",
        "ERROR_MESSAGE": "Não foi possível atualizar as configurações da caixa de entrada. Por favor, tente novamente mais tarde."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Ativado",
        "DISABLED": "Desativado"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Ativado",
        "DISABLED": "Desativado"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Ativado",
        "DISABLED": "Desativado"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Nome do remetente",
        "SUB_TEXT": "Selecione o nome a apresentar aos seus clientes quando receberem e-mails dos seus agentes.",
        "FOR_EG": "Por exemplo:",
        "FRIENDLY": {
          "TITLE": "Amigável",
          "FROM": "de",
          "SUBTITLE": "Adicionar o nome do agente que enviou a resposta ao remetente, para a tornar mais pessoal."
        },
        "PROFESSIONAL": {
          "TITLE": "Profissional",
          "SUBTITLE": "Usar apenas o nome da empresa como nome do remetente no cabeçalho do e-mail."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ Configure o nome da sua empresa",
          "PLACEHOLDER": "Insira o nome da sua empresa",
          "SAVE_BUTTON_TEXT": "Guardar"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Ativado",
        "DISABLED": "Desativado"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Ativado",
        "DISABLED": "Desativado"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "Nenhum"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Ativado",
        "DISABLED": "Desativado"
      },
      "ENABLE_HMAC": {
        "LABEL": "Ativar"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Ativado",
        "DISABLED": "Inativo"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Ativado",
        "DISABLED": "Inativo"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Ativar a sincronização de e-mails recebidos"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Ativar domínio de e-mail personalizado (serviço pago)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Ativar o processamento de comentários do Facebook"
      },
      "SIGNATURE": {
        "TITLE": "Assinatura HTML",
        "SUB_TEXT": "Esta assinatura será adicionada ao rodapé de todas as mensagens enviadas a partir desta caixa de entrada.",
        "HTML_CONTENT": "Código HTML",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} será substituído pelo nome do agente.\n{'{{'}email{'}}'} será substituído pelo endereço de e-mail do agente que enviou o e-mail.\n{'{{'}position{'}}'} será substituído pelo cargo do agente.\n{'{{'}custom_line{'}}'} será substituído pela linha personalizada do agente.\n{'{{'}email_signature_picture{'}}'} será substituído pelo URL da imagem de assinatura de e-mail do agente (não é uma tag de imagem) — utilize-o como origem da imagem (o src de uma tag img).",
        "PREVIEW": "Pré-visualização"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Assinaturas por país",
        "SUB_TEXT": "Uma resposta recebe a assinatura do país do comprador.",
        "HELP": "Uma resposta é assinada de acordo com o país da conversa: a loja Kaufland, o marketplace do pedido Allegro ou, caso contrário, o idioma em que o comprador escreve. Quando o país é desconhecido ou não tem assinatura aqui, é utilizada a assinatura HTML acima. Os marketplaces proíbem links para o seu site e dados de contacto, por isso limite-se a uma saudação e a {'{{'}name{'}}'}.",
        "EMPTY": "Ainda não tem assinaturas por país, por isso as respostas utilizam a assinatura HTML acima.",
        "COUNTRY": "Selecione um país",
        "ADD": "Adicionar assinatura por país",
        "REMOVE": "Remover"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Prefixo de marcação do número de telefone",
        "PLACEHOLDER": "Introduza o prefixo para o encaminhamento correto das chamadas (ex.: *99)",
        "HELP_TEXT": "Este prefixo será adicionado automaticamente antes dos números de telefone dos contactos ao marcar a partir desta caixa de entrada."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "Texto do botão «resolver mais tarde»",
        "PLACEHOLDER": "ex.: Vamos resolver este tópico por e-mail. Agora quero perguntar outra coisa.",
        "HELP_TEXT": "Texto do botão do widget que permite ao visitante sair do tópico atual e perguntar outra coisa. Se deixar o campo vazio, será usado o texto predefinido no idioma do visitante."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Adiar automaticamente chamadas perdidas por X minutos",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Adia automaticamente as chamadas perdidas pelo número de minutos especificado. Deixe vazio ou 0 para desativar."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Resolver uma chamada perdida após X retornos de chamada sem sucesso",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Quando uma chamada perdida for devolvida X vezes sem que o cliente atenda, é resolvida automaticamente e é adicionada uma nota privada. Deixe vazio ou 0 para desativar."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Sugestões de perguntas",
        "SUB_TEXT": "Configure perguntas predefinidas que os clientes podem utilizar para interagir com os seus agentes.",
        "QUESTIONS_LABEL": "Perguntas",
        "ADD_QUESTION": "Adicionar pergunta",
        "REMOVE": "Remover",
        "QUESTION_TEXT": "Texto apresentado na bolha.",
        "QUESTION_TEXT_PLACEHOLDER": "Obrigatório",
        "QUESTION_PAYLOAD": "Texto enviado ao clicar.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "Opcional",
        "NO_BOT_MESSAGE": "Para gerar sugestões adicionais de IA, ligue um bot.",
        "BOT_CONNECTED_MESSAGE": "As sugestões de perguntas de IA do bot podem ser ativadas nas suas",
        "BOT_SETTINGS_LINK": "definições"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "E-mails alternativos",
        "SUB_TEXT": "Endereços adicionais que esta caixa de entrada deve tratar como seus ao receber e-mails encaminhados.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Adicionar",
        "REMOVE": "Remover",
        "EMPTY": "Nenhum e-mail alternativo configurado.",
        "HELP_TEXT": "Quando um e-mail chegar com um destes endereços como destinatário, as respostas serão enviadas com o mesmo endereço como remetente. Certifique-se de que o seu servidor SMTP de saída permite o envio a partir destes endereços.",
        "SIGNATURE_LABEL": "Assinatura",
        "PRIMARY_SIGNATURE": "Principal (predefinição)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "Assinaturas adicionais",
        "SUB_TEXT": "Defina aqui assinaturas adicionais e, em seguida, atribua-as aos e-mails alternativos abaixo.",
        "OPTION": "Assinatura {number}",
        "ADD": "Adicionar assinatura",
        "REMOVE": "Remover",
        "HELP_TEXT": "Quando uma resposta é enviada a partir de um e-mail alternativo, é utilizada a assinatura que lhe está atribuída em vez da assinatura da caixa de entrada. Os e-mails alternativos deixados em «Principal (predefinição)» voltam a usar a assinatura da caixa de entrada."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Excluir",
      "AVATAR_DELETE_BUTTON_TEXT": "Excluir avatar",
      "DELETE_REQUESTED_TOOLTIP": "Esta caixa de entrada está marcada para exclusão",
      "RESTORE_BUTTON_TEXT": "Restaurar",
      "CONFIRM": {
        "TITLE": "Confirmar exclusão",
        "MESSAGE": "Tem certeza que pretende excluir ",
        "PLACE_HOLDER": "Por favor, digite {inboxName} para confirmar",
        "YES": "Sim, excluir ",
        "NO": "Não, manter "
      },
      "API": {
        "SUCCESS_MESSAGE": "Caixa de entrada excluída com sucesso",
        "MARKED_FOR_DELETION_MESSAGE": "Caixa de entrada marcada para exclusão",
        "RESTORE_SUCCESS_MESSAGE": "Caixa de entrada restaurada com sucesso",
        "ERROR_MESSAGE": "Não foi possível excluir a caixa de entrada. Por favor, tente novamente mais tarde.",
        "RESTORE_ERROR_MESSAGE": "Não foi possível restaurar a caixa de entrada. Tente novamente mais tarde.",
        "AVATAR_SUCCESS_MESSAGE": "Avatar da caixa de entrada excluído com sucesso",
        "AVATAR_ERROR_MESSAGE": "Não foi possível excluir o avatar da caixa de entrada. Por favor, tente novamente mais tarde."
      }
    },
    "TABS": {
      "SETTINGS": "Configurações",
      "COLLABORATORS": "Colaboradores",
      "AUTOMATIC_PRIORITY": "Prioridade automática",
      "AUTOMATIC_LABELING": "Etiquetagem automática",
      "CONFIGURATION": "Configuração",
      "CAMPAIGN": "Campanhas",
      "PRE_CHAT_FORM": "Formulário pré-chat",
      "BUSINESS_HOURS": "Horário comercial",
      "WIDGET_BUILDER": "Construtor de widgets",
      "BOT_CONFIGURATION": "Configuração do bot",
      "SLA": "SLA"
    },
    "SETTINGS": "Configurações",
    "FEATURES": {
      "LABEL": "Características",
      "DISPLAY_FILE_PICKER": "Mostrar o selecionador de ficheiros no widget",
      "DISPLAY_EMOJI_PICKER": "Mostrar selecionador de emojis no widget",
      "ALLOW_END_CONVERSATION": "Permitir que os utilizadores terminem a conversa a partir da widget",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Mostrar o botão 'Iniciar nova conversa' no cabeçalho do widget",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Ocultar campo de entrada quando o botão iniciar nova conversa for exibido",
      "SHOW_HANDOFF_BUTTON": "Mostrar o botão 'Transferir para um operador' no cabeçalho do widget",
      "AUTO_CLOSE_OLD": "Marcar todas as chamadas anteriores do mesmo número como resolvidas depois de uma ser resolvida",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Atribuir automaticamente chamadas perdidas ao efetuar uma chamada de saída",
      "USE_INBOX_AVATAR_FOR_BOT": "Usar o nome da caixa de entrada e o avatar do bot",
      "ALLOW_OFFLINE_REPLY": "Permitir que os agentes enviem mensagens quando o contacto está offline e a continuidade por e-mail não está disponível"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Script do Messenger",
      "MESSENGER_SUB_HEAD": "Coloque este botão no corpo da sua tag ",
      "INBOX_AGENTS": "Agentes",
      "INBOX_TEAMS": "Equipas",
      "INBOX_COOPERATORS": "Colaboradores",
      "SELECT_PLACEHOLDER": "Selecionar",
      "AGENTS_OR_TEAMS_INFO": "Pode atribuir agentes ou equipas - não ambos em simultâneo.",
      "INBOX_AGENTS_SUB_TEXT": "Adicionar ou remover agentes desta caixa de entrada",
      "AGENT_ASSIGNMENT": "Atribuição da conversa",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Atualizar configurações de atribuição de conversa",
      "UPDATE": "Atualização",
      "ENABLE_EMAIL_COLLECT_BOX": "Ativar caixa de receção de e-mail",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Ativar ou desativar caixa de receção de e-mails para as novas conversas",
      "AUTO_ASSIGNMENT": "Ativar atribuição automática",
      "ENABLE_CSAT": "Ativar CSAT",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "Ativar CSAT em cada mensagem",
      "SENDER_NAME_SECTION": "Adicionar o nome do agente ao e-mail",
      "ENABLE_CSAT_SUB_TEXT": "Ativar/Desativar envio do questionário CSAT (satisfação do cliente) depois de resolver uma conversa",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "Ativar/desativar a opção de inquérito CSAT para cada mensagem enviada pelos agentes",
      "SENDER_NAME_SECTION_TEXT": "Ativar/Desativar exibição do nome do agente no e-mail. Se estiver desativado, exibirá o nome da empresa",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Ativar continuidade das conversas por e-mail",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "As conversas irão continuar por e-mail se o endereço de e-mail do contacto estiver disponível.",
      "RESPOND_FROM_EMAIL": "Responder a partir do e-mail",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "Os e-mails para o cliente — tanto as respostas como as transcrições da conversa — são enviados através das definições SMTP da caixa de entrada de e-mail selecionada, a partir do endereço selecionado (o endereço da própria caixa de entrada ou um dos seus aliases), e as respostas do cliente chegam através do seu endereço IMAP.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "As transcrições da conversa são enviadas através das definições SMTP da caixa de entrada de e-mail selecionada, a partir do endereço selecionado (o endereço da própria caixa de entrada ou um dos seus aliases), com as respostas a chegar através do seu endereço IMAP.",
      "SHOW_WELCOME_SCREEN": "Mostrar ecrã de boas-vindas",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Mostra o ecrã de boas-vindas quando o widget é aberto. Se desativado, o widget vai diretamente para a vista de conversa.",
      "AUTO_CLOSE_PENDING": "Resolver automaticamente os chats de IA após (horas)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "Resolve automaticamente os chats de IA após X horas de inatividade.",
      "LOCK_TO_SINGLE_CONVERSATION": "Bloquear conversa única",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Ativar ou desativar múltiplas conversas para o mesmo contacto nesta caixa de entrada",
      "INBOX_UPDATE_TITLE": "Configurações da caixa de entrada",
      "INBOX_UPDATE_SUB_TEXT": "Atualize as suas configurações da caixa de entrada",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Ativar ou desativar a atribuição automática de novas conversas aos agentes adicionados a essa caixa de entrada.",
      "HMAC_VERIFICATION": "Validação da identidade do utilizador",
      "HMAC_DESCRIPTION": "Com esta chave, pode gerar um token secreto que pode ser usado para verificar a identidade dos seus utilizadores.",
      "HMAC_ROTATE": {
        "BUTTON": "Rodar chave",
        "TITLE": "Rodar a chave secreta?",
        "WARNING": "A chave atual é revogada no momento em que a rodar.",
        "WARNING_DETAIL": "Não há período de sobreposição e não é possível restaurá-la.",
        "IMPACT": "Os seus servidores têm de assinar os utilizadores com a nova chave. Quem ainda estiver assinado com a chave antiga falha na verificação. Se a validação de identidade for obrigatória, essas pessoas não podem iniciar uma conversa.",
        "CONFIRM": "Rodar chave",
        "CANCEL": "Cancelar",
        "SUCCESS": "Chave secreta rodada com sucesso",
        "ERROR": "Não foi possível rodar a chave secreta, tente novamente"
      },
      "HMAC_LINK_TO_DOCS": "Pode saber mais aqui.",
      "HMAC_MANDATORY_VERIFICATION": "Forçar validação de identidade do utilizador",
      "HMAC_MANDATORY_DESCRIPTION": "Se ativado, os pedidos que não podem ser verificados serão rejeitados.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Forçar nova conversa em cada carregamento do widget",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "Se ativado, abrir o widget num novo separador ou janela inicia uma nova conversa.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Esquecer o contacto quando uma nova conversa é iniciada",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "Se desativado, uma nova conversa iniciada a partir do widget mantém o contacto anterior.",
      "INBOX_IDENTIFIER": "Identificador da caixa de entrada",
      "INBOX_IDENTIFIER_SUB_TEXT": "Use o token 'inbox_identifier' mostrado aqui para autenticar os seus clientes API.",
      "FORWARD_EMAIL_TITLE": "Encaminhar para e-mail",
      "FORWARD_EMAIL_SUB_TEXT": "Comece a encaminhar as suas mensagens de e-mail para o seguinte endereço.",
      "EMAIL_FETCHING_ENABLED_TITLE": "Sincronização de e-mail",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Ativa a sincronização e transferência automática dos e-mails recebidos nesta caixa de entrada",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Domínio de e-mail personalizado",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Ative para utilizar um domínio de e-mail personalizado nos e-mails enviados",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "Pode saber mais aqui.",
      "FACEBOOK_COMMENTS_TITLE": "Comentários do Facebook",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Permitir mensagens após a resolução da conversa",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Permitir que os utilizadores finais enviem mensagens após a conversa estar resolvida.",
      "WIDGET_STATUS_LABEL": "Estado do widget",
      "WIDGET_STATUS_ENABLED": "Ativado",
      "WIDGET_STATUS_BUSINESS_HOURS": "Ativado durante o horário de funcionamento",
      "WIDGET_STATUS_DISABLED": "Desativado",
      "WIDGET_STATUS_HELP_TEXT": "Controla quando o widget é apresentado aos visitantes no seu site",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Atualizar configurações do formulário pré-chat",
      "EXPLICIT_CSAT_LOCALE": "Idioma do inquérito CSAT e do e-mail",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "Escolha o idioma para todos os e-mails dos clientes, incluindo inquéritos CSAT, transcrições de conversas e notificações por e-mail",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "Herdar da conta",
      "WHATSAPP_CONNECTION": {
        "TITLE": "Conexão do WhatsApp",
        "SUBTITLE": "Como esta caixa de entrada está conectada ao WhatsApp.",
        "PROVIDER": "Provedor",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "Conectado pelo cadastro incorporado da Meta",
        "STATUS": "Status",
        "CONNECTED": "Conectado",
        "RECONNECT_HINT": "Clique em Reconectar no aviso acima.",
        "PHONE_NUMBER": "Número de telefone",
        "BUSINESS_ACCOUNT": "ID da conta do WhatsApp Business",
        "OPEN_MANAGER": "Abrir no WhatsApp Manager",
        "PHONE_NUMBER_ID": "ID do número de telefone",
        "TEMPLATES": "Modelos de mensagem",
        "TEMPLATES_COUNT": "{approved} de {total} aprovados",
        "TEMPLATES_SYNCED": "Última sincronização: {date}",
        "TEMPLATES_NOT_SYNCED": "Ainda não sincronizados",
        "MANAGE_TEMPLATES": "Gerenciar modelos"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Centro de suporte",
      "PLACEHOLDER": "Selecione centro de suporte",
      "SELECT_PLACEHOLDER": "Selecione centro de suporte",
      "REMOVE": "Remover centro de suporte",
      "SUB_TEXT": "Associe um centro de suporte à caixa de entrada"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Limite de atribuição automática",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Por favor, insira um valor maior que 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Limitar o número máximo de conversas desta caixa de entrada que pode ser atribuído automaticamente a um agente"
    },
    "SLA": {
      "TITLE": "Políticas de SLA",
      "SUB_TEXT": "Configure os tempos de resposta e resolução de SLA para cada nível de prioridade de conversa.",
      "LOADING": "A carregar políticas de SLA...",
      "FIELDS": {
        "ACTIVE": "Ativo",
        "TICKET_PRIORITY": "Prioridade do ticket",
        "FIRST_RESPONSE_TIME": "Tempo de primeira resposta",
        "EVERY_RESPONSE_TIME": "Tempo de cada resposta",
        "RESOLUTION_TIME": "Tempo de resolução",
        "PLACEHOLDER": "ex.: 1h 30m"
      },
      "API": {
        "SUCCESS_MESSAGE": "Políticas de SLA atualizadas com sucesso.",
        "ERROR_MESSAGE": "Não foi possível atualizar as políticas de SLA. Tente novamente."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Prioridade automática",
      "SUB_TEXT": "Configure a atribuição automática de prioridade com base no conteúdo da conversa.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Aviso de faturação",
        "MESSAGE": "Cada avaliação de prioridade terá um custo. Consulte os detalhes do seu plano para obter informações sobre preços."
      },
      "MODE": {
        "OFF": "Desligado",
        "ALL_MESSAGES": "Ativo para todas as mensagens recebidas",
        "FIRST_MESSAGE": "Ativo apenas para a primeira mensagem recebida"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Configuração dos níveis de prioridade",
        "SUB_TEXT": "Configure quais os níveis de prioridade que devem estar ativos e as suas descrições. Forneça critérios claros para a IA determinar quando esta prioridade deve ser atribuída."
      },
      "DESCRIPTION_LABEL": "Descrição",
      "DESCRIPTION_PLACEHOLDER": "Descreva as conversas a marcar com prioridade {priority}",
      "SET_AS_DEFAULT": "Definir como prioridade predefinida",
      "MULTIPLE_DEFAULTS_WARNING": "Apenas um nível de prioridade deve ser definido como predefinido. Desmarque as outras predefinições."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Etiquetagem automática",
      "SUB_TEXT": "Configure a atribuição automática de etiquetas com base no conteúdo da conversa.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Aviso de faturação",
        "MESSAGE": "Cada avaliação de etiquetagem terá um custo. Consulte os detalhes do seu plano para obter informações sobre preços."
      },
      "MODE": {
        "OFF": "Desligado",
        "CONVERSATION_OPEN": "Ao abrir a conversa",
        "CONVERSATION_CLOSE": "Ao fechar a conversa",
        "ALL_MESSAGES": "Em todas as mensagens - independentemente do estado",
        "FIRST_MESSAGE": "Na primeira mensagem - independentemente do estado"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Configuração de etiquetas",
        "SUB_TEXT": "Configure quais as etiquetas que devem estar disponíveis para atribuição automática e as suas descrições. Forneça critérios claros para a IA determinar quando esta etiqueta deve ser aplicada."
      },
      "DESCRIPTION_LABEL": "Descrição",
      "DESCRIPTION_PLACEHOLDER": "Descreva as conversas a etiquetar como {label}. Se deixar isto vazio, será utilizada a descrição da etiqueta.",
      "NO_LABELS_MESSAGE": "Não foram encontradas etiquetas. Crie etiquetas primeiro para ativar a etiquetagem automática.",
      "CREATE_LABELS_LINK": "Criar etiquetas"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Reautorizar",
      "SUBTITLE": "A sua conexão ao Facebook expirou, por favor, reconecte a página para poder continuar a utilizar os serviços",
      "MESSAGE_SUCCESS": "Reconexão bem-sucedida",
      "MESSAGE_ERROR": "Ocorreu um erro, por favor, tente novamente"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "O formulário de pré-chat permite-lhe capturar informações do utilizador antes de iniciar uma conversa.",
      "SET_FIELDS": "Campos do formulário de pré-chat",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Campos",
        "LABEL": "Etiqueta",
        "PLACE_HOLDER": "Placeholder",
        "KEY": "Chave",
        "TYPE": "Tipo",
        "REQUIRED": "Obrigatório"
      },
      "ENABLE": {
        "LABEL": "Ativar formulário de pré-chat",
        "OPTIONS": {
          "ENABLED": "Sim",
          "DISABLED": "Não"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Mensagem de pré-chat",
        "PLACEHOLDER": "Esta mensagem estará visível aos utilizadores, juntamente com o formulário"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Os visitantes devem digitar o seu nome e e-mail antes de iniciarem uma conversa"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Definir disponibilidade",
      "SUBTITLE": "Defina a sua disponibilidade no widget do livechat",
      "WEEKLY_TITLE": "Defina as suas horas semanais",
      "TIMEZONE_LABEL": "Selecionar fuso horário",
      "UPDATE": "Atualizar as configurações do horário comercial",
      "TOGGLE_AVAILABILITY": "Ativar a disponibilidade de negócios para esta caixa de entrada",
      "UNAVAILABLE_MESSAGE_LABEL": "Mensagem indisponível para os visitantes",
      "TOGGLE_HELP": "Permitir a disponibilidade de negócios mostrará as horas disponíveis no widget de live-chat, mesmo que todos os agentes estejam offline. Em caso de contactos fora do horário disponível, os clientes podem ser avisados com uma mensagem e um formulário de pré-chat.",
      "DAY": {
        "ENABLE": "Ativar a disponibilidade para este dia",
        "UNAVAILABLE": "Indisponível",
        "HOURS": "horas",
        "VALIDATION_ERROR": "A hora de abertura deve ser anterior à hora de encerramento.",
        "CHOOSE": "Escolher"
      },
      "ALL_DAY": "Todo o dia",
      "SAVE_TO_ALL": "Guardar em todas as caixas de entrada",
      "SAVE_TO_ALL_TITLE": "Copiar horário comercial",
      "SAVE_TO_ALL_CONFIRM": "As definições deste formulário (alternância de disponibilidade, mensagem de ausência, fuso horário e horário comercial) serão copiadas para todas as outras caixas de entrada, exceto as de e-mail e telefone. Tem a certeza que pretende continuar?",
      "SAVE_TO_ALL_CANCEL": "Cancelar",
      "SAVE_TO_ALL_YES": "Sim, copiar para todas",
      "SAVE_TO_ALL_SUCCESS": "Horário comercial copiado para todas as outras caixas de entrada com sucesso",
      "SAVE_TO_ALL_ERROR": "Não foi possível copiar o horário comercial para as outras caixas de entrada"
    },
    "PHONE": {
      "TITLE": "Configurações de telefone",
      "SUBTITLE": "Configure que chamadas aparecem nesta caixa de entrada.",
      "UPDATE": "Guardar configurações",
      "EDIT": {
        "SUCCESS_MESSAGE": "Configurações de telefone atualizadas"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Números de telefone",
        "PLACEHOLDER": "+145123908635"
      }
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Defina os seus dados IMAP",
      "NOTE_TEXT": "Para ativar o SMTP, por favor, configure o IMAP.",
      "UPDATE": "Atualizar configurações IMAP",
      "TOGGLE_AVAILABILITY": "Ativar a configuração IMAP para esta caixa de entrada",
      "TOGGLE_HELP": "Habilitar o IMAP ajudará o utilizador a receber o e-mail",
      "EDIT": {
        "SUCCESS_MESSAGE": "Configurações IMAP atualizadas com sucesso",
        "ERROR_MESSAGE": "Não foi possível atualizar as configurações do IMAP"
      },
      "ADDRESS": {
        "LABEL": "Endereço",
        "PLACE_HOLDER": "Endereço (Ex. imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Porta",
        "PLACE_HOLDER": "Porta"
      },
      "LOGIN": {
        "LABEL": "Iniciar sessão",
        "PLACE_HOLDER": "Iniciar sessão"
      },
      "PASSWORD": {
        "LABEL": "Palavra-passe",
        "PLACE_HOLDER": "Palavra-passe"
      },
      "ENABLE_SSL": "Ativar SSL"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Autorizar novamente a sua conta Microsoft"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Defina os seus dados IMAP",
      "UPDATE": "Atualizar configurações de SMTP",
      "TOGGLE_AVAILABILITY": "Ativar a configuração IMAP para esta caixa de entrada",
      "TOGGLE_HELP": "Habilitar o SMTP ajudará o utilizador a enviar e-mail",
      "EDIT": {
        "SUCCESS_MESSAGE": "Configurações de SMTP atualizadas com sucesso",
        "ERROR_MESSAGE": "Não é possível atualizar as configurações de SMTP"
      },
      "ADDRESS": {
        "LABEL": "Endereço",
        "PLACE_HOLDER": "Endereço (Ex. smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Porta",
        "PLACE_HOLDER": "Porta"
      },
      "LOGIN": {
        "LABEL": "Iniciar sessão",
        "PLACE_HOLDER": "Iniciar sessão"
      },
      "PASSWORD": {
        "LABEL": "Palavra-passe",
        "PLACE_HOLDER": "Palavra-passe"
      },
      "DOMAIN": {
        "LABEL": "Domínio",
        "PLACE_HOLDER": "Domínio"
      },
      "ENCRYPTION": "Encriptação",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Abrir o modo de verificação SSL",
      "AUTH_MECHANISM": "Autenticação"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "Capacidade de entrega de e-mail (DNS)",
      "SUB_TITLE": "Verificamos os registos SPF, DKIM, DMARC e MX de {domain} todos os dias úteis. Quando algo faz com que os servidores recetores rejeitem as suas respostas ou as enviem para o spam, os administradores recebem um e-mail com a correção.",
      "RUN": "Executar verificação",
      "RUN_SUCCESS": "Verificação de DNS concluída",
      "RUN_ERROR": "Não foi possível executar a verificação de DNS, tente novamente",
      "NOT_CHECKED": "Ainda não verificado.",
      "CHECKED_AT": "Última verificação: {time}.",
      "DNS_UNAVAILABLE": "A última verificação não obteve resposta dos servidores de nomes do domínio. O resultado abaixo é da verificação anterior.",
      "SENDER": {
        "SMTP": "As respostas são enviadas através de {host}.",
        "PLATFORM": "As respostas são enviadas através dos nossos servidores de correio."
      },
      "STATUS": {
        "OK": "Todos os registos estão em ordem",
        "WARNING": "Alguns registos podiam estar melhor",
        "ERROR": "As respostas podem não chegar aos destinatários",
        "UNKNOWN": "Desconhecido"
      },
      "SEVERITY": {
        "ERROR": "Problema",
        "WARNING": "Aviso"
      },
      "FIX": "Corrija com este registo DNS:",
      "RECORD_TYPE": "Tipo",
      "RECORD_HOST": "Nome",
      "RECORD_VALUE": "Valor",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "Falta o registo SPF",
          "DESCRIPTION": "O domínio não indica quais os servidores autorizados a enviar o seu e-mail. Muitos servidores de correio tratam então as suas respostas como spam. Adicione um registo SPF que permita {sender}."
        },
        "spf_multiple": {
          "TITLE": "O domínio tem {count} registos SPF",
          "DESCRIPTION": "Um domínio só pode ter um registo SPF. Havendo mais, os servidores recetores ignoram o SPF e muitas vezes rejeitam o e-mail. Una-os num único registo."
        },
        "spf_not_authorized": {
          "TITLE": "O SPF não permite o servidor que envia as suas respostas",
          "DESCRIPTION": "As suas respostas são enviadas através de {sender}, mas o registo SPF do domínio não o inclui. Registo atual: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "O registo SPF necessita de demasiadas consultas DNS",
          "DESCRIPTION": "Os servidores recetores deixam de verificar o SPF após {limit} consultas DNS, mas {sender}, que envia as suas respostas, só é alcançado após {lookups}. As suas respostas falham o SPF. Mova {sender} para o início do registo e remova os include que o domínio já não utiliza."
        },
        "spf_lookups_others": {
          "TITLE": "Alguns remetentes do registo SPF estão além do limite de consultas",
          "DESCRIPTION": "O registo SPF necessita de {lookups} consultas DNS e os servidores recetores param após {limit}. As suas respostas são avaliadas a tempo e passam, mas o e-mail destes remetentes falha o SPF: {senders}. Remova os include que o domínio já não utiliza."
        },
        "spf_malformed": {
          "TITLE": "O registo SPF está danificado",
          "DESCRIPTION": "Os servidores recetores não conseguem ler o registo SPF do domínio, pelo que este não protege as suas respostas. O problema está em: {terms}. Substitua o registo pelo corrigido."
        },
        "dkim_missing": {
          "TITLE": "A assinatura DKIM não está configurada",
          "DESCRIPTION": "Não encontrámos nenhuma chave DKIM em {selectors}. Sem ela, as suas respostas não são assinadas e é mais provável que acabem no spam. Ative a assinatura DKIM para o domínio junto do seu fornecedor de e-mail."
        },
        "dmarc_missing": {
          "TITLE": "Falta o registo DMARC",
          "DESCRIPTION": "Grandes fornecedores de e-mail, como o Gmail e a Microsoft, esperam um registo DMARC. Sem ele, é mais provável que as suas respostas acabem no spam."
        },
        "dmarc_fails": {
          "TITLE": "O DMARC indica aos destinatários que rejeitem as suas respostas",
          "DESCRIPTION": "A política DMARC do domínio é “{policy}” e as suas respostas não passam nem no SPF nem no DKIM, pelo que os destinatários as rejeitam ou as enviam para o spam. Corrija o SPF e o DKIM acima."
        },
        "dmarc_blocks_platform": {
          "TITLE": "O DMARC bloqueia as respostas enviadas através dos nossos servidores de correio",
          "DESCRIPTION": "Esta caixa de entrada envia respostas através dos nossos servidores de correio, mas a política DMARC do domínio é “{policy}”, pelo que os destinatários as rejeitam ou as enviam para o spam. Configure o SMTP do seu próprio servidor de correio para esta caixa de entrada."
        },
        "mx_missing": {
          "TITLE": "O domínio não tem registo MX",
          "DESCRIPTION": "Sem um registo MX, ninguém pode enviar e-mails para o domínio, pelo que os clientes não conseguem responder às suas respostas."
        }
      }
    },
    "NOTE": "Observação: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Avatar do website",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar removido com sucesso",
              "ERROR_MESSAGE": "Ocorreu um erro, por favor, tente novamente"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Nome do website",
          "PLACE_HOLDER": "Insira o nome do seu website (ex. Acme Inc)",
          "ERROR": "Por favor, insira um nome de website válido"
        },
        "WELCOME_HEADING": {
          "LABEL": "Título de boas-vindas",
          "PLACE_HOLDER": "Olá!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Slogan de boas-vindas",
          "PLACE_HOLDER": "Nós simplificamos a sua conexão connosco. Pergunte-nos qualquer coisa ou partilhe um comentário."
        },
        "REPLY_TIME": {
          "LABEL": "Tempo de resposta",
          "IN_A_FEW_MINUTES": "Em poucos minutos",
          "IN_A_FEW_HOURS": "Em poucas horas",
          "IN_A_DAY": "Dentro de um dia"
        },
        "WIDGET_COLOR_LABEL": "Cor do widget",
        "WIDGET_BUBBLE_POSITION_LABEL": "Posição do balão de widget",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Altura máxima das mensagens não lidas (px)",
          "PLACE_HOLDER": "Sem limite",
          "HELP_TEXT": "Limite a altura máxima da janela de mensagens não lidas em píxeis. Deixe em branco para o comportamento predefinido (sem limite)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Tipo de balão de widget",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Fale connosco",
          "LABEL": "Título do inicializador do balão de widget",
          "PLACE_HOLDER": "Fale connosco"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Atualizar configurações do widget",
          "API": {
            "SUCCESS_MESSAGE": "Configurações do widget atualizadas com sucesso",
            "ERROR_MESSAGE": "Não é possível atualizar as configurações do widget"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Pré-visualizar",
          "SCRIPT": "Script"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Esquerda",
          "RIGHT": "Direita"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Padrão",
          "EXPANDED_BUBBLE": "Balão expandido"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Padrão",
        "CHAT": "Chat"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Normalmente respondemos em poucos minutos",
        "IN_A_FEW_HOURS": "Normalmente respondemos em poucas horas",
        "IN_A_DAY": "Normalmente respondemos num dia"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Iniciar conversa",
        "CHAT_INPUT_PLACEHOLDER": "Escreva a sua mensagem"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Estamos online",
          "OFFLINE": "Neste momento, estamos ausentes"
        },
        "USER_MESSAGE": "Olá",
        "AGENT_MESSAGE": "Olá"
      },
      "BRANDING_TEXT": "Desenvolvido por JARABOT",
      "SCRIPT_SETTINGS": "\n      window.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Outros fornecedores"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Site",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "SMS_BRANA": "SMS Brana",
      "DIDWW": "DIDWW",
      "EMAIL": "E-mail",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "Canal da API",
      "PHONE": "Telefone SIP",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    }
  }
}
